import { render, staticRenderFns } from "./grab.vue?vue&type=template&id=fde9674a&scoped=true"
import script from "./grab.vue?vue&type=script&lang=js"
export * from "./grab.vue?vue&type=script&lang=js"
import style0 from "./grab.vue?vue&type=style&index=0&id=fde9674a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde9674a",
  null
  
)

export default component.exports